import styled from 'styled-components/macro';
import { lighten } from 'polished';
import { COLORS, TYPOGRAPHY } from 'styleguide';

const PrimaryButton = styled.button`
  padding: 5px 16px;
  border: none;
  background-color: ${COLORS.primary};
  color: #fff;
  text-align: center;
  border-radius: 4px;
  ${TYPOGRAPHY.button}
  cursor: pointer;
  outline: none;
  transition: background-color 0.15s ease-out;

  &:hover {
    background-color: ${lighten(0.12, COLORS.primary)};
  }

  &:focus {
    background-color: ${lighten(0.12, COLORS.primary)};
    box-shadow: 0 0 8px 0 ${COLORS.primary};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export default PrimaryButton;
